import styled from 'styled-components';

export const StyledCodeGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 16px;
  margin: 0;
  padding: 16px;
  list-style: none;
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  li {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 15px;
    letter-spacing: 0.08em;
    text-align: center;
  }
`;
